import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import { getCdnUrl } from '@/utils/Images';
import Text from '@/components/Text';

function MemojiList({
  numMemojis = 3,
  maxMemojis = 3,
  size = 32,
  bordered = false,
  themeClassName
}) {

  const [memojis, setMemojis] = useState<any>([]);

  const loadMemojis = () => {
    if (!memojis?.length) {
      const mems: Array<any> = [];
      for (let i = 0; i < numMemojis; i++) {
        const randomInt = Math.ceil(Math.random() * 45) + 1;
        if (!mems.includes(randomInt)) {
          mems.push(randomInt);
        }
      }

      setMemojis(mems);
    }
  };

  useEffect(() => {
    !memojis?.length && loadMemojis();
  }, [memojis?.length]);

  return (
    <div className={twMerge('ml-4 -mt-0.5 flex items-center flex-row')}>
      {memojis.slice(1, maxMemojis).map((e) => (
        <div
          className={ twMerge('bg-white rounded-full flex items-center justify-center -ml-2', bordered ? 'border-2' : '', `size-[${size}px]`)}
          key={e}
        >
          <Image
            alt='participant'
            src={`${getCdnUrl()}/memojis/${e}.png`}
            className={twMerge(size && `size-[${size}px]`)}
            width={size}
            height={size}
          />
        </div>
      ))}
      {(numMemojis > maxMemojis && <div className={twMerge('rounded-full flex-none flex items-center justify-center gap-1 -ml-2 font-semibold p-2', themeClassName)}><Text size="xs">+</Text><Text size="xs">{numMemojis - maxMemojis || 0}</Text></div>)}
    </div>
  );
}

export default MemojiList;
